import { WithHeader, WithSeeMore } from "react-insta-stories";
import { isMobile } from "react-device-detect";
import { IoIosArrowUp } from "react-icons/io";
import { eAssetType } from "../../@types/Asset";
import { sample } from "lodash";
import useStoredImage from "../../hooks/useStoredImage";

/**
 * this function get the news data from back-end and generated an array of Stories to be used in react-insta-stories package.
 * @param {array} data
 * @returns {array}
 */
export default function GetStoriesNews(data) {
  const { newsData, assetType, icon, assetName } = data;
  var storiesNews = [];

  newsData
    .slice(0)
    .reverse()
    .forEach((newsItem) => {
      let newsTimestamp = newsItem.dateTimestamp;
      let daysDiff = getDaysDiff(newsTimestamp);

      let newsTimestampMore30Days = new Date(newsItem.dateTimestamp * 1000);
      newsTimestampMore30Days.setDate(newsTimestampMore30Days.getDate() + 30);
      let actualDate = new Date();

      //Only add to the stories with less than 30 days of publication.
      if (newsTimestampMore30Days.getTime() > actualDate.getTime()) {
        let background = getStoriesImageBackground(assetType);
        let seeMoreButton = ({ action }) =>
          newsItem.linkExternal && (
            <div className="mg-b-10" style={{ textAlign: "center" }}>
              <div
                onClick={() => {
                  action("pause");
                  window.open(newsItem.linkExternal, "_blank");
                }}
                style={{ color: "white", cursor: "pointer" }}
              >
                <IoIosArrowUp />
                <br />
                Ler mais
              </div>
            </div>
          );
        return storiesNews.push({
          header: {
            heading: assetName,
            subheading: daysDiff,
            profileImage: icon,
          },
          newsItem,
          seeMore: () => false,
          duration: 7000,
          content: ({ story, config, action }) => {
            return (
              <WithHeader story={story} globalHeader={config.header}>
                <WithSeeMore
                  story={story}
                  action={action}
                  customCollapsed={seeMoreButton}
                >
                  <div
                    style={{
                      background: `linear-gradient( rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.5) ), url('${background.image}') no-repeat`,
                      paddingTop: "100%",
                      paddingBottom: "100%",
                    }}
                    className="animated fadeInDown"
                  >
                    <div
                      style={{
                        paddingLeft: isMobile ? 10 : 50,
                        paddingRight: isMobile ? 10 : 50,
                        borderRadius: 10,
                      }}
                    >
                      <div
                        className="card"
                        style={{
                          marginTop: isMobile ? 50 : 0,
                          background: "rgba(255,255,255,0.2)",
                          borderRadius: 10,
                          border: "none",
                        }}
                      >
                        <div className="card-body">
                          <h2
                            style={{
                              marginTop: 5,
                              color: background.textsColors,
                              filter:
                                "drop-shadow(rgba(0, 0, 0, 0.7) 0px 0px 3px)",
                            }}
                          >
                            {newsItem.name}
                          </h2>
                          <h5
                            style={{
                              color: background.textsColors,
                              filter:
                                "drop-shadow(rgba(0, 0, 0, 0.7) 0px 0px 3px)",
                            }}
                          >
                            {newsItem.content}
                          </h5>
                        </div>
                      </div>
                      <div
                        className="footer mg-t-10 mg-l-10"
                        style={{
                          color: background.textsColors,
                          filter: "drop-shadow(rgba(0, 0, 0, 0.7) 0px 0px 3px)",
                        }}
                      >
                        Fonte: {newsItem.providerName}
                      </div>
                    </div>
                  </div>
                </WithSeeMore>
              </WithHeader>
            );
          },
        });
      }
    });

  if (storiesNews.length > 0) {
    return storiesNews;
  } else {
    return false;
  }
}

/**
 * returns an Object with background image and textcolors according to the assetType
 * @param {Number} assetType
 * @returns {Object}
 */
export function getStoriesImageBackground(assetType) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { getBackgroundImageSrc } = useStoredImage();
  const stockBackgrounds = [
    "stockBackground1.jpg",
    "stockBackground2.jpg",
    "stockBackground3.jpg",
    "stockBackground4.jpg",
    "stockBackground5.jpg",
    "stockBackground6.jpg",
    "stockBackground7.jpg",
  ];

  const forexBackgrounds = [
    "forexBackground1.jpg",
    "forexBackground2.jpg",
    "forexBackground3.jpg",
    "forexBackground4.jpg",
    "forexBackground5.jpg",
    "forexBackground6.jpg",
    "forexBackground7.jpg",
  ];

  const criptoBackgrounds = [
    "criptoBackground1.jpg",
    "criptoBackground2.jpg",
    "criptoBackground3.jpg",
    "criptoBackground4.jpg",
    "criptoBackground5.jpg",
    "criptoBackground6.jpg",
    "criptoBackground7.jpg",
  ];

  let background = "";
  switch (assetType) {
    case eAssetType.STOCK:
      background = sample(stockBackgrounds) ?? "stockBackground1.jpg";
      break;
    case eAssetType.FOREX:
      background = sample(forexBackgrounds) ?? "forexBackground1.jpg";
      break;
    case eAssetType.CRIPTO:
      background = sample(criptoBackgrounds) ?? "criptoBackground1.jpg";
      break;
    default:
      background = "stockBackground2.jpg";
      break;
  }

  return {
    image: getBackgroundImageSrc(background),
    textsColors: "rgba(255,255,255,1.0)",
  };
}

/**
 * Get a news timestamp and compare to the actual date -
 * pick the diference and return in days.
 * @param {number} newsTimestamp
 * @returns {string}
 */
const getDaysDiff = (newsTimestamp) => {
  let newsItemDate = new Date(newsTimestamp * 1000);
  let actualDate = new Date();
  const diffTime = Math.abs(actualDate - newsItemDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  const hoursdiff = Math.ceil(diffTime / (60 * 60 * 1000));

  if (hoursdiff <= 24) {
    //if this news is from today
    return "Há " + hoursdiff + " horas atrás";
  } else {
    if (diffDays === 0) {
      return "Hoje";
    } else if (diffDays === 1) {
      return "Há um dia atrás.";
    } else {
      return "Há " + diffDays + " dias atrás";
    }
  }
};
